var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteBinFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 5.0013H18.3327V6.66797H16.666V17.5013C16.666 17.9616 16.2929 18.3346 15.8327 18.3346H4.16602C3.70578 18.3346 3.33268 17.9616 3.33268 17.5013V6.66797H1.66602V5.0013H5.83268V2.5013C5.83268 2.04107 6.20578 1.66797 6.66602 1.66797H13.3327C13.7929 1.66797 14.166 2.04107 14.166 2.5013V5.0013ZM7.49935 9.16797V14.168H9.16602V9.16797H7.49935ZM10.8327 9.16797V14.168H12.4993V9.16797H10.8327ZM7.49935 3.33464V5.0013H12.4993V3.33464H7.49935Z",
    fill: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBinFill);
export default __webpack_public_path__ + "static/media/delete-bin-fill.53f25bb52167b1386e688e6900e81e8c.svg";
export { ForwardRef as ReactComponent };